import React, { useState } from 'react';
import CommentForm from './CommentForm';
import styles from './styles/ScenarioComments.module.css';

const CommentItem = React.memo(({ comment, currentUser, onLike, onUpdate, onDelete }) => {
    const [isEditing, setIsEditing] = useState(false);

    const [likeState, setLikeState] = useState({
        isLiked: comment.isLiked,
        likesCount: comment.likesCount
    });

    const isOwner = currentUser && (currentUser._id === comment.sender._id || currentUser._id === comment.sender);

    const handleLikeClick = async () => {
        if (!currentUser) return alert("Please login to like.");

        const previousState = { ...likeState };
        const newIsLiked = !likeState.isLiked;
        const newCount = newIsLiked ? likeState.likesCount + 1 : likeState.likesCount - 1;

        setLikeState({ isLiked: newIsLiked, likesCount: newCount });

        try {
            await onLike(comment._id);
        } catch (error) {
            setLikeState(previousState);
            console.error("Like failed", error);
        }
    };

    const handleUpdateSubmit = async (newMessage) => {
        await onUpdate(comment._id, newMessage);
        setIsEditing(false);
    };

    const handleDeleteClick = () => {
        if (window.confirm("Are you sure you want to delete this comment?")) {
            onDelete(comment._id);
        }
    };

    return (
        <div className={styles.commentItem}>
            <div className={styles.commentHeader}>
                {comment.sender.profilePicture && (
                    <img
                        src={comment.sender.profilePicture}
                        alt={comment.sender.username}
                        className={styles.authorAvatar}
                    />
                )}
                <strong className={styles.authorName}>
                    {comment.sender.username || "Unknown User"}
                </strong>
                <span className={styles.commentDate}>
                    {new Date(comment.createdAt).toLocaleDateString(undefined, {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                    })}
                </span>
            </div>

            {isEditing ? (
                <div className={styles.editWrapper}>
                    <CommentForm 
                        initialValue={comment.message} 
                        onSubmit={handleUpdateSubmit} 
                        isEditMode={true}
                        onCancel={() => setIsEditing(false)}
                    />
                </div>
            ) : (
                <p className={styles.commentBody}>{comment.message}</p>
            )}
            
            <div className={styles.commentActions}>
                <button 
                    onClick={handleLikeClick} 
                    className={`${styles.actionButton} ${likeState.isLiked ? styles.likedButton : ''}`}
                >
                    {likeState.isLiked ? 'Unlike ' : 'Like '} 
                    <span className={styles.likeCount}>({likeState.likesCount})</span>
                </button>

                {isOwner && !isEditing && (
                    <>
                        <button onClick={() => setIsEditing(true)} className={styles.actionButton}>
                            Edit
                        </button>
                        <button onClick={handleDeleteClick} className={styles.deleteButton}>
                            Delete
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}, (prevProps, nextProps) => {
    return (
        prevProps.comment._id === nextProps.comment._id &&
        prevProps.comment.message === nextProps.comment.message &&
        prevProps.comment.likesCount === nextProps.comment.likesCount &&
        prevProps.comment.isLiked === nextProps.comment.isLiked &&
        prevProps.currentUser === nextProps.currentUser
    );
});

export default CommentItem
